import type { FredrickLocalDebugExportV1 } from 'fredrick-local-repository';

export function serializeFredrickDebugExport(value: FredrickLocalDebugExportV1): string {
  return `${JSON.stringify(value, null, 2)}\n`;
}

export function fredrickDebugExportFileName(exportedAt: number): string {
  if (!Number.isFinite(exportedAt)) throw new RangeError('exportedAt must be finite.');
  const timestamp = new Date(exportedAt).toISOString().replaceAll(':', '-').replaceAll('.', '-');
  return `fredrick-debug-${timestamp}.json`;
}

export function downloadFredrickDebugExport(value: FredrickLocalDebugExportV1): void {
  const blob = new Blob([serializeFredrickDebugExport(value)], {
    type: 'application/json;charset=utf-8',
  });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fredrickDebugExportFileName(value.exportedAt);
  anchor.hidden = true;
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 0);
}
